import { useState, useEffect } from 'react';
import Modal from '@mui/material/Modal';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

const userSettingModalStyle = {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    height: '100%'
};

export default function FinishModal({ openModal, redeemID, t, config, from, msg, handleCloseModal }) {
    const setting = config.scannerErr_setting;
    const [open, setOpen] = useState(false);

    useEffect(() => {
        if (open !== openModal) setOpen(openModal);
    }, [openModal]);

    return (
        <>
            <Modal
                open={open}
                // onClose={handleClose}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
            >
                <div className="modal" style={{ height: from ? '160px' : '200px' }}>
                    {!from ? (
                        <>
                            <CheckCircleOutlineIcon style={{ color: config.theme.color }} />
                            <h2 style={{ marginTop: '10px' }}>{t('redeeemSuccess_txt_line1')}</h2>
                            <h3>
                                {t('recordsPage_recordNum') + " "}#{redeemID}
                            </h3>
                        </>
                    ) : (
                        <div style={userSettingModalStyle}>
                            <h3>{msg}</h3>

                            <button
                                className="colorBtn"
                                style={{
                                    minHeight: '35px'
                                }}
                                onClick={handleCloseModal}
                            >
                                {t(`${setting.buttons[0].label}`)}
                            </button>
                        </div>
                    )}
                </div>
            </Modal>

            <style jsx="true">{`
                .modal {
                    color: #41413a;
                    background-color: #ffffff;
                    border-radius: 5px;
                    text-align: center;
                    width: 320px;
                    height: 200px;
                    padding: 10px 20px 35px;
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                }

                .modal:focus {
                    outline: none !important;
                }
            `}</style>
        </>
    );
}
